import React from 'react';
import "./ExperienceComponent.css";


export default function ExperienceComponent(props){

    var experiences = props.experiences.map((exp, i) => 
        <Experience company = {exp.company}
        duration = {exp.duration}
        resp = {exp.resp}
        link = {exp.link}
        img = {exp.img}
        />
    )

    return (
        <div className = "experience">
            {experiences}
        </div>
    )
}


function Experience(props){

    return (
        <div className = "experience-component">
            <div className = "experience-component-image">
                <img onClick = {function(){
                    window.open(props.link);
                }} alt = "" src = {props.img}></img>
            </div>
            <div className = "experience-component-desc">
                <div className = "experience-title">{props.company}</div>
                <div className = "experience-duration">{props.duration}</div>
                <div className = "experience-desc">{props.resp}</div>
            </div>
        </div>
    )

}
